import { useDataRefresh, ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AgencyAdminService } from 'twia-capability-agencyadmin';
import metadata from './AddAgency.metadata.json5';
import styles from './AddAgency.module.scss';
import AddNewUser from '../../components/AddNewUser/AddNewUser';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useAuthentication, withAuthenticationContext } from '@xengage/gw-digital-auth-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import _, { isEmpty, isUndefined } from 'lodash';
import { useTranslator } from '@jutro/locale';
import messages from './AddAgency.messages';

function AddAgency(props) {
    const [addAgency, updateAddAgencyVM] = useState();
    const viewModelService = useContext(ViewModelServiceContext);
    const { refreshData } = useDataRefresh();
    const [userExistsMessage, setUserExistMessage] = useState("");
    const [countUser, setCountUser] = useState();
    const [userRoles, setUserRoles] = useState([]);
    const [orgsUser, setOrgsUser] = useState([]);
    const [noUserFlag, setNoUserFlag] = useState(false);
    const { authHeader } = useAuthentication();
    const [addNewUserVisible, setAddNewUserVisible] = useState(false);
    const { onValidate, isComponentValid, registerComponentValidation } = useValidation('AddAgency');
    const {
        id, getAddAgencyContent, associationName_TWIA
    } = props;
    const translator = useTranslator();
    const [emailValidationMessage, setEmailValidationMessage] = useState([]);
    const [zipCodeValidationMessage, setZipCodeValidationMessage] = useState([]);
    const [showErrors, setShowErrors] = useState(false);
    

    useEffect(() => {
        let dtoPathProducer = '';
        const dtoPathPerson = 'edge.capabilities.gateway.contact.dto.PersonDTO';
        const dtoPathAddress = 'edge.capabilities.address.dto.AddressDTO';

        //DE15365 added check for association Name
        if (associationName_TWIA === 'twia') {
            dtoPathProducer = 'org.twia.elevate.edge.capabilities.agent.dto.ProducerGroupDTO'
        }
        else {
            dtoPathProducer = 'org.tfpa.edge.capabilities.agent.dto.ProducerGroupDTO'
        }

        const addAgencyVM = viewModelService.create(
            {},
            'pc',
            dtoPathProducer
        );

        addAgencyVM.primaryPersonContact = viewModelService.create(
            {},
            'pc',
            dtoPathPerson
        ).value;
        addAgencyVM.primaryPersonContact.primaryAddress = viewModelService.create(
            { country: 'US' },
            'pc',
            dtoPathAddress
        ).value;
        updateAddAgencyVM(addAgencyVM);
    }, []);

    useCallback(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
    }, [id, isComponentValid, onValidate]);


    const getAddAgencyContentValue = useCallback((value) => {
        getAddAgencyContent(value);
    })

    const updateVM = useCallback((addAgencyNewVM) => {
        updateAddAgencyVM(addAgencyNewVM);
        refreshData();
    },[refreshData,updateAddAgencyVM])

    const onUserSearch = useCallback(() => {

        if (!_.isEmpty(_.get(addAgency, 'primaryPersonContact.emailAddress1.value')) && addAgency.primaryPersonContact.emailAddress1.aspects.valid) {
            if (associationName_TWIA === 'twia') {
                setUserRoles([]);
                setOrgsUser({});
                AgencyAdminService.countUsersWithEmail(_.get(addAgency, 'primaryPersonContact.emailAddress1.value'), null, authHeader).then((matchingUsersCountResponse) => {
                    setCountUser(matchingUsersCountResponse);

                    if (matchingUsersCountResponse > 0) {

                        AgencyAdminService.searchUsersInOrgByEmail(_.get(addAgency, 'primaryPersonContact.emailAddress1.value'), null, authHeader).then((matchingUsersResponse) => {
                            // setUserRoles(matchingUsersResponse.orgUsers);
                            setOrgsUser(matchingUsersResponse.orgUsers)
                            setNoUserFlag(false);
                            setAddNewUserVisible(true);

                            if (matchingUsersResponse.orgUsers.length === 0) {
                                setUserExistMessage("User Already Exists");

                            }
                        });

                    } else {
                        setOrgsUser(undefined);
                        AgencyAdminService.getUserWithRoles(true, authHeader).then((val) => {
                            if (val !== undefined) {
                                setUserRoles(val.userRoles);
                                setOrgsUser(undefined);
                                setAddNewUserVisible(true);
                            }

                            setNoUserFlag(true);

                        });

                    }
                }).finally(() => {

                });
            }
            else {
                //DE15365 added calls related to TFPA
                onUserSearch_tfpa();
            }

        }

    }, [addAgency, authHeader, userRoles, noUserFlag])

    const onUserSearch_tfpa = useCallback(() => {
        setUserRoles([]);
        setOrgsUser({});
        AgencyAdminService.countUsersWithEmail_tfpa(_.get(addAgency, 'primaryPersonContact.emailAddress1.value'), authHeader).then((matchingUsersCountResponse) => {
            setCountUser(matchingUsersCountResponse);

            if (matchingUsersCountResponse > 0) {
                AgencyAdminService.searchUsersInOrgByEmail_tfpa(_.get(addAgency, 'primaryPersonContact.emailAddress1.value'), authHeader).then((matchingUsersResponse) => {

                    // DE15401
                    if (_.isEmpty(matchingUsersResponse.orgUsers)) {
                        setCountUser(0);
                        setOrgsUser(undefined);
                        AgencyAdminService.getUserWithRoles_tfpa(true, authHeader).then((val) => {
                            if (val !== undefined) {
                                setUserRoles(val.userRoles);
                                setOrgsUser(undefined);
                                setAddNewUserVisible(true);
                            }

                            setNoUserFlag(true);

                        });

                    } else {
                        // setUserRoles(matchingUsersResponse.orgUsers);
                        setOrgsUser(matchingUsersResponse.orgUsers)
                        setNoUserFlag(false);
                        setAddNewUserVisible(true);

                        if (matchingUsersResponse.orgUsers.length === 0) {
                            setUserExistMessage("User Already Exists");

                        }
                    }

                });

            } else {
                setOrgsUser(undefined);
                AgencyAdminService.getUserWithRoles_tfpa(true, authHeader).then((val) => {
                    if (val !== undefined) {
                        setUserRoles(val.userRoles);
                        setOrgsUser(undefined);
                        setAddNewUserVisible(true);
                    }

                    setNoUserFlag(true);

                });

            }
        }).finally(() => {

        });
    }, [addAgency, authHeader])

    const writeValue = useCallback(
        (value, path) => {
            _.set(addAgency, path, value);

            if (path === 'primaryPersonContact.emailAddress1') {
                setAddNewUserVisible(false);
            }

            if (!addAgency.primaryPersonContact.emailAddress1.aspects.valid) {
                setEmailValidationMessage([translator(messages.EmailValidationMessage)])
            }

            if (path === 'primaryPersonContact.primaryAddress.postalCode' && !_.isEmpty(addAgency.primaryPersonContact.primaryAddress.postalCode.value)) {
                setZipCodeValidationMessage([translator(messages.ZipCodeValidationMessage)])
            }
            else{
                setZipCodeValidationMessage([translator(messages.ZipCodeValidationRequiredMessage)])
            }

            updateAddAgencyVM(addAgency);
            refreshData();
        },
        [refreshData, addAgency, addNewUserVisible]
    );

    const parentFieldValidation=useCallback(()=>{
        if (!isComponentValid) {
            setShowErrors(true)
          }
    },[isComponentValid])
    

    const overrideProps = {
        //DE15410
        '@field': {
            labelPosition: 'left',
            showErrors,
            phoneWide: {
                labelPosition: 'top',
            },
          },
        addNewUser: {
            visible: !isUndefined(userRoles),
            addAgency,
            countUser,
            userRoles,
            orgsUser,
            isParentValid: isComponentValid,
            getAddAgencyContentValue,
            addNewUserVisible,
            associationName_TWIA,
            updateVM,
            parentFieldValidation
        },
        noUserMessage: {
            message: translator(messages.noUserFound),
            visible: noUserFlag && addNewUserVisible
        },
        email: {
            validationMessages: addAgency?.primaryPersonContact?.emailAddress1?.aspects?.valid ? [] : emailValidationMessage
        },
        zipCode:{
            validationMessages: addAgency?.primaryPersonContact?.primaryAddress?.postalCode?.aspects?.valid ? [] : zipCodeValidationMessage
        }
    };
    const resolvers = {
        resolveClassNameMap: styles,
        resolveComponentMap: {
            addNewAgencyUser: AddNewUser
        },
        resolveCallbackMap: {
            onUserSearch,
            getAddAgencyContentValue
        }
    };
    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            model={addAgency}
            onValueChange={writeValue}
            overrideProps={overrideProps}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
            callbackMap={resolvers.resolveCallbackMap}
            onValidationChange={onValidate}
        />
    );
}

AddAgency.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
    }).isRequired,
    authHeader: PropTypes.shape({}).isRequired
};

AddAgency.defaultProps = {

};

export default withAuthenticationContext(withRouter(AddAgency));
